export const INITIAL_SURVEY_TO_SHOW = 1
export const EXPIRY_PERIOD = 3 * 24 * 60 * 60 * 1000
export const SURVEY_TIMEOUT_TO_SHOW = 1 * 60 * 1000
export const SURVEY_COUNT_LIMIT = 9
export const SURVEY_DATA_LOCAL_STORAGE_KEY = 'survey_data_v2'
export const SURVEY_SESSION_ACTIVE_KEY = 'survey_session_active'
export const SURVEY_SHOWN_THIS_SESSION_KEY = 'survey_shown_this_session'
